import React from 'react'
import { makeStyles } from '@material-ui/core'
import { useTranslate } from 'react-admin'
import profileSettingsInfoEmailFormStyles from './profileSettingsInfoEmailForm.styles'
import MySimpleTextField from '../../../components/form/fields/MySimpleTextField'
import ContainerPadding from '../../../components/containerPadding/containerPadding'
import userType from '../../../types/userType'

// Email change is intentionally disabled (frontend only): the edit icon and the
// UpdateEmailModal / updateUserData flow were removed from this form.
// Before re-enabling it, read the analysis in DEV-1073:
// https://app.clickup.com/t/2386510/DEV-1073
const ProfileSettingsInfoEmailForm = ({ userData }) => {
  const { email } = userData
  const translate = useTranslate()
  const useStyles = makeStyles(profileSettingsInfoEmailFormStyles)
  const classes = useStyles()

  return (
    <ContainerPadding padding='4% 1% 4% 1%'>
      <div className={classes.divFlex}>
        <MySimpleTextField value={email ?? ''} label={translate('ra.formFields.email')} disabled />
      </div>
    </ContainerPadding>
  )
}

ProfileSettingsInfoEmailForm.propTypes = {
  userData: userType,
}

export default ProfileSettingsInfoEmailForm
